import { useMutation } from '@hooks/reactQuery';

import { checkPolygonName } from '@api/map';

import { CHECK_POLYGON_NAME } from '@constants/queryKeys';

export const useMutateCheckPolygonName = () => {
	const { isLoading: isChecking, mutateAsync: checkName } = useMutation<string>({
		mutationKey: [CHECK_POLYGON_NAME],
		mutationFn: checkPolygonName,
		onError: () => null,
	});

	return {
		isChecking,
		checkName,
	};
};
